export const PartnersPath = {
  base: 'partners'
};
